import { get, writable } from "svelte/store";
import API from "../../../API/API";
import AuthStore from "../../../Auth/Store";
import DateDialect from "../../../Enums/DateDialect";
import LoadState from "../../../Enums/LoadState";
import Company from "../../../Models/Company";
import User from "../../../Models/User";

const UserPreferencesStore = {
	dashboard: {
		meta: {
			visible: writable(false),
			initState: writable(LoadState.INIT),
			loadState: writable(LoadState.INIT),
			error: writable("")
		},
		data: {
			currentUser: writable(null)
		},
		actions: {
			init: () => {
				return new Promise((resolve, reject) => {
					if (get(UserPreferencesStore.dashboard.meta.initState) !== LoadState.INIT) {
						resolve();
						return;
					}

					UserPreferencesStore.dashboard.meta.initState.set(LoadState.LOADING);

					return Promise.all([
						API.currentUser()
					])
						.then((responses) => {
							const userResponse = responses[0];

							const company = new Company(userResponse.company);
							const user = new User(userResponse.user);
							user.company = company;
							UserPreferencesStore.dashboard.data.currentUser.set(user);

							UserPreferencesStore.dashboard.meta.initState.set(LoadState.LOADED);
							resolve();
						})
						.catch((error) => {
							console.error("error", error);
							UserPreferencesStore.dashboard.meta.error.set(error.data.detail);
							UserPreferencesStore.dashboard.meta.initState.set(LoadState.INIT);
							reject(error);
						});
				});
			},
			savePreferences: (lngLatFormat, bathymetryEnabled, mapViewType, mapViewOpacity) => {
				return new Promise((resolve, reject) => {
					UserPreferencesStore.dashboard.meta.loadState.set(LoadState.LOADING);
					const data = {
						extra_data: {
							settings: {
								date_dialect: DateDialect.NULL, // dateDialect,
								lnglat_format: lngLatFormat,
								map: {
									bathymetry_enabled: bathymetryEnabled,
									view_type: mapViewType,
									view_opacity: mapViewOpacity
								}
							}
						}
					};
					console.log("data", data);
					API.put("users/current/preferences", data)
						.then((response) => {
							console.log("response", response);

							const user = get(AuthStore.session.user);
							user.extraData = response.user.extra_data;
							AuthStore.session.user.set(user);

							const dashboardUser = get(UserPreferencesStore.dashboard.data.currentUser);
							dashboardUser.extraData = response.user.extra_data;
							UserPreferencesStore.dashboard.data.currentUser.set(dashboardUser);

							UserPreferencesStore.dashboard.meta.loadState.set(LoadState.INIT);

							AuthStore.actions.save();
							resolve();
						})
						.catch((err) => {
							console.error("err", err);
							UserPreferencesStore.dashboard.meta.error.set(err);
							UserPreferencesStore.dashboard.meta.loadState.set(LoadState.INIT);
							reject(err);
						});
				});
			}
		}
	}
};
export default UserPreferencesStore;
